import { render, staticRenderFns } from "./baseMail.vue?vue&type=template&id=5bfe7d9f&scoped=true"
import script from "./baseMail.vue?vue&type=script&lang=js"
export * from "./baseMail.vue?vue&type=script&lang=js"
import style0 from "./baseMail.vue?vue&type=style&index=0&id=5bfe7d9f&prod&lang=scss"
import style1 from "./baseMail.vue?vue&type=style&index=1&id=5bfe7d9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe7d9f",
  null
  
)

export default component.exports